import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { Components, Logger } from "@sendum/core";

import * as VisibilityActions from "./store/VisibilityActions";
import { VisibilityRootState } from "./store/VisibilityStore";
import { VisibilityMarkenSensors } from "./components/VisibilityMarkenSensors";
import { VisibilityHistoryTable } from "./components/VisibilityHistoryTable";

import classes from "./VisibilityVirtual.module.scss";
import { VisibilityMap } from "./components/VisibilityMap";
import { VisibilityAlarms } from "./components/VisibilityAlarms";
import { VisibilityGraphsTimeline } from "./components/VisibilityGraphsTimeline";
import { AnyAction } from "redux";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const logger = new Logger("VisibilityVirtual");
const MAX_ACTIVE_SENSORS = 6;

export interface IProps {
	name: string;
}

export const VisibilityVirtual = ({ name }: IProps): JSX.Element => {
	const dispatch = useDispatch();
	const shipment = useSelector((state: VisibilityRootState) => state.Visibility.shipment, shallowEqual);
	const multiplePlaceComponent = useSelector((state: VisibilityRootState) => state.Visibility.multiplePlaceComponent, shallowEqual);
	const isLoadingShipments = useSelector((state: VisibilityRootState) => state.Visibility.isLoadingShipments, shallowEqual);
	const error = useSelector((state: VisibilityRootState) => state.Visibility.error, shallowEqual);

	useEffect(() => {
		dispatch(VisibilityActions.getShipments(name) as unknown as AnyAction);
	}, [dispatch, name]);

	if (isLoadingShipments) {
		return (<Components.Loader className={classes.loader} text={"Loading"} />);
	}

	if (error !== undefined) {
		return (<Components.ErrorComponent error={error} />);
	}

	return (
		<div className={classes.visibility}>
			<div className={classes.visibility__column}>
				<div className={classNames(classes.visibility__item, classes.visibility__dewar)}>
					HAWB: {shipment?.masterTrackingNo}  | Client Id: {shipment?.name || "---"}  |  Container: {shipment?.cargoes[0]?.containerId || "---"}  |  Device: {shipment?.devices[0]?.displayName || "---"}
				</div>
				<div className={classes.visibility__item}>
					<VisibilityMarkenSensors maxActiveSensors={MAX_ACTIVE_SENSORS} />
				</div>
				<div className={classNames(classes.visibility__item, classes.visibility__multipleBlock)}>
					<div className={classes.multipleBlock__row}>
						<VisibilityGraphsTimeline
							className={classNames(classes.multipleBlock__item, classes.multipleBlock__graph)}
							maxSensors={MAX_ACTIVE_SENSORS}
							virtualShipmentName={name}
						/>
						{multiplePlaceComponent === "alarms"
							? (<VisibilityAlarms className={classes.multipleBlock__item} />)
							: (<VisibilityMap className={classNames(classes.multipleBlock__item, classes.multipleBlock__map)} />)
						}
					</div>
				</div>
				<div className={classes.visibility__item}>
					<VisibilityHistoryTable virtualShipmentName={name} />
				</div>
			</div>
		</div>
	);
};
